export default __webpack_public_path__ + "static/media/popupTransitionPro.961d5392.m4v";